import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserPermissions } from '../../hooks/useUserPermissions';

/**
 * Settings index page - redirects to the first available settings page
 * based on user permissions
 */
export const Settings = () => {
  const navigate = useNavigate();
  const permissions = useUserPermissions();

  useEffect(() => {
    if (permissions.isLoading) {
      return;
    }

    // Redirect to first available settings page
    if (permissions.isAdmin || permissions.isTenantSettings) {
      navigate('/settings/tenant', { replace: true });
    // SAM-38: Roles redirect temporarily disabled
    // } else if (permissions.isRolesManager) {
    //   navigate('/settings/roles', { replace: true });
    } else {
      // No settings access, redirect to dashboard
      navigate('/dashboard', { replace: true });
    }
  }, [permissions, navigate]);

  return null;
};
